var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoMeetingRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:none;stroke:#898e9a;stroke-linecap:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__pict-sdr",
    transform: "translate(-12 -11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_359",
    width: 48,
    height: 48,
    fill: "none",
    "data-name": "Rectangle 359",
    rx: 2,
    transform: "translate(12 11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__ico-sdr",
    transform: "translate(14 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Groupe_84",
    "data-name": "Groupe 84",
    transform: "translate(0 3.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_125",
    d: "M142.213 523.684h-5.821c-2.6 0-4.366-2.6-4.366-5.3v-12.007a2.368 2.368 0 0 1 2.651-2.34h3.223c1.455 0 2.072.883 3.063 1.715s2.707 2.34 2.707 2.34h5.995c1.438 0 1.369 3.014 0 3.014h-6.255l-6.4-2.339",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 125",
    transform: "translate(-132.026 -494.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_126",
    d: "M144.059 515.361v5.539h3.327a4.579 4.579 0 0 1 4.314 3.014c.624 1.976 2.911 10.135 2.911 10.135",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 126",
    transform: "translate(-136.211 -497.469)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_7",
    cx: 3.865,
    cy: 3.865,
    r: 3.865,
    className: "prefix__cls-2",
    "data-name": "Ellipse 7",
    transform: "translate(1.092)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Groupe_85",
    "data-name": "Groupe 85",
    transform: "translate(24.809 3.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_127",
    d: "M178.305 523.684h5.822c2.6 0 4.366-2.6 4.366-5.3v-12.007a2.368 2.368 0 0 0-2.651-2.34h-3.222c-1.456 0-2.072.883-3.064 1.715s-2.706 2.34-2.706 2.34h-6c-1.438 0-1.368 3.014 0 3.014h6.255l6.4-2.339",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 127",
    transform: "translate(-169.802 -494.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_128",
    d: "M180.8 515.361v5.539h-3.326a4.579 4.579 0 0 0-4.314 3.014c-.624 1.976-2.911 10.135-2.911 10.135",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 128",
    transform: "translate(-169.957 -497.469)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_8",
    cx: 3.865,
    cy: 3.865,
    r: 3.865,
    className: "prefix__cls-2",
    "data-name": "Ellipse 8",
    transform: "translate(9.869)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Groupe_86",
    "data-name": "Groupe 86",
    transform: "translate(14.385)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_9",
    cx: 3.865,
    cy: 3.865,
    r: 3.865,
    className: "prefix__cls-2",
    "data-name": "Ellipse 9",
    transform: "translate(3.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_129",
    d: "M153.952 503.878a4.573 4.573 0 0 1 4.574-4.573h5.436a4.574 4.574 0 0 1 4.574 4.573",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 129",
    transform: "translate(-153.952 -489.611)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMeetingRoom);
export default __webpack_public_path__ + "static/media/picto-meeting-room.b89a4295c1ece0c48a6b3771df7dd67d.svg";
export { ForwardRef as ReactComponent };